import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // Log sempre - util para diagnostico via DevTools console
    console.error('ErrorBoundary caught an error:', error);
    console.error('Component stack:', errorInfo?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleHome = () => {
    // Limpa estado e leva o usuario para o dashboard padrao
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      const errMsg = this.state.error?.message || this.state.error?.toString() || 'erro desconhecido';
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="h-16 w-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="h-8 w-8 text-orange-600" />
            </div>
            <h1 className="text-xl font-bold text-slate-800 mb-2">
              Ops! Algo deu errado
            </h1>
            <p className="text-slate-600 mb-3">
              Ocorreu um erro inesperado. Você pode voltar ao Dashboard e tentar novamente.
            </p>
            <details className="mb-4 text-left text-xs text-red-700 bg-red-50 border border-red-200 rounded p-3">
              <summary className="cursor-pointer font-medium">Detalhes técnicos (clique para expandir)</summary>
              <p className="mt-2 font-mono break-all">{errMsg}</p>
              {process.env.NODE_ENV === 'development' && this.state.errorInfo?.componentStack && (
                <pre className="mt-2 overflow-auto text-[10px]">{this.state.errorInfo.componentStack}</pre>
              )}
            </details>
            <div className="flex gap-2 justify-center flex-wrap">
              <Button onClick={this.handleHome} variant="outline" data-testid="btn-error-home">
                <Home className="h-4 w-4 mr-1" /> Dashboard
              </Button>
              <Button onClick={this.handleReset} variant="outline" data-testid="btn-error-retry">
                Tentar novamente
              </Button>
              <Button onClick={this.handleReload} className="bg-luvcorp-navy hover:bg-luvcorp-navy-dark text-white" data-testid="btn-error-reload">
                <RefreshCw className="h-4 w-4 mr-1" /> Recarregar
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
